import axios from "axios";
import { toast } from "react-toastify";

let is_production = true;
const URL = getEnviromentUrl();

const APICORSCONFIG = {
  headers: {
    "Access-Control-Allow-Origin": "*",
    "Access-Control-Allow-Headers": "Authorization",
    "Access-Control-Allow-Methods": "GET, POST, OPTIONS, PUT, PATCH, DELETE",
    "Content-Type": "application/json;charset=UTF-8",
    Authorization: `Bearer ${getToken()}`,
  },
};

function getToken() {
  return localStorage.getItem("hondixTk");
}

export async function get(method, fullUrl = false) {
  const url = !fullUrl ? `${URL}${method}` : method;
  // console.log("url", url);
  // console.group("GET REQUEST:");
  // console.log("url", url);
  let result = await axios.get(url, APICORSCONFIG);
  // console.log("result", result);
  // console.groupEnd();
  return result;
}

export async function FullUrlget(url) {
  // console.group("GET REQUEST:");
  // console.log("url", url);
  let result = await axios.get(url);
  // console.log("result", result);
  // console.groupEnd();
  return result;
}

export async function post(method, body) {
  try {
    // console.group("POST REQUEST:");
    const url = `${URL}${method}`;
    // console.log("URL", URL);
    let result = await axios.post(url, body, APICORSCONFIG);
    if (result.data.statusCode === 200) {
      toast.success("Item inserido com sucesso.");
    }
    // console.groupEnd();
    return result;
  } catch (error) {
    console.error("error", error);
  }
}

export async function put(method, body) {
  try {
    // console.group("PUT REQUEST:");
    const url = `${URL}${method}`;
    let result = await axios.put(url, body, APICORSCONFIG);
    // console.log("result", result);
    toast.success("Item atualizado com sucesso.");
    // console.groupEnd();
    return result;
  } catch (error) {
    toast.error("Erro ao atualizar dados.");
  }
}

export async function sendDelete(method) {
  try {
    // console.group("DELTE REQUEST:");
    const url = `${URL}${method}`;
    let result = await axios.delete(url, APICORSCONFIG);
    // console.log("result", result);
    if (result.status !== 200) {
      toast.error("Erro ao apagar dados.");
    }
    toast.success("Item apagado com sucesso.");
    // console.groupEnd();
    return result;
  } catch (error) {
    toast.error("Erro ao apagar dados.");
  }
}

export async function setNewPass(method, token) {
  const url = `${URL}${method}`;
  const tk = {
    headers: {
      "Access-Control-Allow-Origin": "*",
      "Access-Control-Allow-Headers": "Authorization",
      "Access-Control-Allow-Methods": "GET, POST, OPTIONS, PUT, PATCH, DELETE",
      "Content-Type": "application/json;charset=UTF-8",
      Authorization: `Bearer ${token}`,
    },
  };

  let result = await axios.get(url, tk);
  return result;
}

export function getEnviromentUrl() {
  // console.log('process.env.API_URL_PROD', process.env.API_URL_PROD)
  // return process.env.IS_PRODUCTION ? process.env.API_URL_PROD : process.env.API_URL_DEV
  return !is_production
    ? "https://localhost:5001/api/"
    : "https://api.hondix.app.br/api/";
}
